var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrap" }, [
    _c("div", { staticClass: "calculate" }, [
      _c("div", { staticClass: "calculate__container" }, [
        _c(
          "div",
          { staticClass: "calculate__animation" },
          [
            _c("vLottiePlayer", {
              staticStyle: { width: "100%", height: "100%" },
              attrs: {
                animationData: require("./assets/lottie/loading.json"),
                background: "transparent",
                speed: "1",
                loop: "",
                autoplay: ""
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("p", { staticClass: "title" }, [_vm._v("결과를 확인중이에요!")])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dd174f9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dd174f9","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/myprotein-test/calculate.vue
// module id = null
// module chunks = 